import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, IconButton, SxProps } from '@mui/material';

type Props = {
    canScrollLeft: boolean;
    canScrollRight: boolean;
    onScrollLeft: () => void;
    onScrollRight: () => void;
    /** Width of the fade overlay area. Default 48 */
    fadeWidth?: number;
    /** Button size (width & height). Omit for default IconButton sizing */
    buttonSize?: number;
    /** Icon font size prop. Default undefined (uses icon default) */
    iconFontSize?: 'small' | 'inherit' | 'medium' | 'large';
    /** Background opacity for the gradient. Default 0.9 */
    gradientOpacity?: number;
};

export default function ScrollNavButtons({
    canScrollLeft,
    canScrollRight,
    onScrollLeft,
    onScrollRight,
    fadeWidth = 48,
    buttonSize,
    iconFontSize,
    gradientOpacity = 0.9,
}: Props) {
    const baseSx: SxProps = {
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: fadeWidth,
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'opacity 0.2s',
    };

    const btnSx: SxProps = {
        bgcolor: 'rgba(0,0,0,0.5)',
        color: '#fff',
        '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' },
        ...(buttonSize ? { width: buttonSize, height: buttonSize } : {}),
    };

    return (
        <>
            {/* Left */}
            <Box
                sx={{
                    ...baseSx,
                    left: 0,
                    background: `linear-gradient(to right, rgba(255,255,255,${gradientOpacity}) 0%, transparent 100%)`,
                    opacity: canScrollLeft ? 1 : 0,
                    pointerEvents: canScrollLeft ? 'auto' : 'none',
                }}
            >
                <IconButton size="small" onClick={onScrollLeft} sx={btnSx}>
                    <ChevronLeftIcon fontSize={iconFontSize} />
                </IconButton>
            </Box>

            {/* Right */}
            <Box
                sx={{
                    ...baseSx,
                    right: 0,
                    background: `linear-gradient(to left, rgba(255,255,255,${gradientOpacity}) 0%, transparent 100%)`,
                    opacity: canScrollRight ? 1 : 0,
                    pointerEvents: canScrollRight ? 'auto' : 'none',
                }}
            >
                <IconButton size="small" onClick={onScrollRight} sx={btnSx}>
                    <ChevronRightIcon fontSize={iconFontSize} />
                </IconButton>
            </Box>
        </>
    );
}
